import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'fms-page-header-description',
	templateUrl: 'page-header-description.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class PageHeaderDescriptionComponent {}
